import { RouteGuard } from 'Src/ng2/routing/guards/route-guard/route-guard';
export const homeRoute = {
  path: 'home',
  url: '/home',
  canActivateChild: [RouteGuard],
  loadChildren: () => import('./home.module').then(m => m.HomeModule),
};
